import { FiltersDropdown } from '@shared/components/ui/FiltersDropdown';
import { Search } from '@shared/components/ui/Search';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PrintersFiltersPanel } from './PrintersFiltersPanel';

interface FiltersSectionProps {
  handleSearch: (value: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
  // If the parent passes initial conditions (not present in original file props but good practice)
  filterConditions?: FilterConditionOutput[];
}

export const FiltersSection = ({ handleSearch, onFilterChange, filterConditions = [] }: FiltersSectionProps) => {
  const { t } = useTranslation('printersModule');
  const { t: tUI } = useTranslation('ui');

  // 🎯 Estado local - NO causa re-render del componente padre
  const [inputValue, setInputValue] = useState('');

  // 🎯 Memoizar handler para evitar bucle infinito
  const handleFilterChange = useCallback(
    (conditions: FilterConditionOutput[]) => {
      onFilterChange?.(conditions);
    },
    [onFilterChange],
  );

  // 🎯 Handler para el cambio del input - Solo afecta al estado local
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  // 🎯 Handler para ejecutar búsqueda - Solo comunica al padre cuando necesario
  const handleSearchSubmit = () => {
    handleSearch(inputValue);
  };

  const activeFiltersCount = filterConditions.length;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
        wrapperClassName="sm:flex-1 sm:max-w-md"
      />
      <FiltersDropdown
        title={tUI('advancedFilter.filters', 'Filtros')}
        activeFiltersCount={activeFiltersCount}
        dropdownContentClassName="sm:min-w-[350px] sm:max-w-[400px] p-4 bg-body-bg text-foreground border border-card-border"
      >
        <PrintersFiltersPanel initialConditions={filterConditions} onChange={handleFilterChange} />
      </FiltersDropdown>
    </div>
  );
};
